import mapImg from "../assets/contact_map.png"; 
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ToastContainer , toast } from "react-toastify";
import React , {useState} from 'react';
const API = process.env.REACT_APP_API_URL

export default function ContactUs() {

  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const validateForm = (formData) => {
    const newErrors = {};
    
    if (!formData.firstName.trim()) newErrors.firstName = "First name is required";
    if (!formData.lastName.trim()) newErrors.lastName = "Last name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Valid email is required";
    if (!formData.phone.trim()) newErrors.phone = "Phone number is required";
    if (!formData.requirement.trim()) newErrors.requirement = "Requirement is required";
    if (!formData.discovery) newErrors.discovery = "Please tell us how you heard about us";
    
    return newErrors;
  };

  const handleSubmit = async(e) =>{
    e.preventDefault();
    
    const formData = {
      firstName: e.target.firstName.value,
      lastName: e.target.lastName.value,
      email: e.target.email.value,
      phone: e.target.phone.value,
      requirement: e.target.requirement.value,
      discovery: e.target.discovery.value,
    };

    const validationErrors = validateForm(formData);
    
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error("Please fill all required fields");
      return;
    }
    
    setErrors({});
    setIsLoading(true);

    try {
      const response = await fetch(`${API}/email/send-contact-request`,{
        method:'POST',
        headers: { 'Content-Type':'application/json'},
        body: JSON.stringify(formData)
      });
      
      if (response.ok) {
        toast.success('Message sent successfully');
        e.target.reset();
      } else {
        toast.error('Failed to send message');
      }
    } catch (error) {
      console.log(error);
      toast.error('Something went wrong');
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <ToastContainer/>
      <div className="bg-white">
      <Header />
      
      {/* Hero Section with Blue Gradient Background */}
      <section className="w-full min-h-screen bg-[radial-gradient(at_top_left,_var(--tw-gradient-stops))] from-blue-100 via-white to-indigo-50 px-6 md:px-12 pt-20 pb-16">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">

          {/* LEFT SIDE: Info */}
          <div className="space-y-10">
            <div>
              <h1 className="text-5xl md:text-6xl font-black text-gray-900 mb-6 tracking-tight">
                Let's build the <br /> 
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                  future together
                </span>
              </h1>
              <p className="text-gray-500 text-lg max-w-md leading-relaxed">
                Have questions about Adeya IMS? Our team is here to help you unlock your business potential.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
              <ContactInfo 
                icon={<path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5" />}
                title="Registered Office"
                detail="UI MIDC Phase 4, Akola, Maharashtra 444001, India"
              />
              <ContactInfo 
                icon={<path d="M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 01-2 2zm9-13.5V9" />}
                title="Corporate Office"
                detail="Raheja Woods, Kalyani Nagar, Pune, Maharashtra 411006, India"
              />
              <ContactInfo 
                icon={<path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />}
                title="Email Us"
                detail="sales@adeyaai.com"
                subDetail="support@adeyaai.com"
                isLink
              />
              <ContactInfo 
                icon={<path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />}
                title="Call Support"
                detail="+91 98221 34536"
              />
            </div>
          </div>

          {/* RIGHT SIDE: Premium Blue Form */}
          <div className="relative">
            {/* Background decorative blob */}
            <div className="absolute -top-10 -right-10 w-64 h-64 bg-blue-200 rounded-full blur-3xl opacity-40 animate-pulse"></div>
            
            <div className="relative bg-white/70 backdrop-blur-xl rounded-[2.5rem] p-8 md:p-10 shadow-[0_20px_50px_rgba(37,99,235,0.1)] border border-white">
              <h3 className="text-2xl font-bold text-gray-900 mb-8">Send us a message</h3>
              
              <form onSubmit={handleSubmit} className="space-y-5">
                <div className="grid grid-cols-2 gap-4">
                  <InputGroup 
                    name="firstName" 
                    label="First Name" 
                    placeholder="John" 
                    required 
                    error={errors.firstName}
                  />
                  <InputGroup 
                    name="lastName" 
                    label="Last Name" 
                    placeholder="Doe" 
                    required 
                    error={errors.lastName}
                  />
                </div>

                <InputGroup 
                  name="email" 
                  label="Your Email" 
                  type="email" 
                  placeholder="john@example.com" 
                  required 
                  error={errors.email}
                />
                <InputGroup 
                  name="phone" 
                  label="Your Phone" 
                  type="tel" 
                  placeholder="+91 00000 00000" 
                  required 
                  error={errors.phone}
                />

                <div className="flex flex-col gap-1">
                  <label className="text-xs font-bold text-blue-600 uppercase tracking-widest ml-1">Requirement <span className="text-red-400">*</span></label>
                  <textarea 
                    name="requirement"
                    rows="3" 
                    placeholder="Tell us about your inventory management needs..."
                    className={`w-full px-4 py-3 rounded-2xl bg-blue-50/50 border ${errors.requirement ? 'border-red-400' : 'border-blue-100'} focus:bg-white focus:ring-2 focus:ring-blue-200 outline-none transition-all resize-none`}
                  ></textarea>
                  {errors.requirement && <p className="text-red-500 text-xs ml-1">{errors.requirement}</p>}
                </div>

                <div className="flex flex-col gap-1">
                  <label className="text-xs font-bold text-blue-600 uppercase tracking-widest ml-1">Discovery <span className="text-red-400">*</span></label>
                  <select 
                    name="discovery" 
                    className={`w-full px-4 py-3 rounded-2xl bg-blue-50/50 border ${errors.discovery ? 'border-red-400' : 'border-blue-100'} focus:bg-white focus:ring-2 focus:ring-blue-200 outline-none transition-all appearance-none cursor-pointer`}
                  >
                    <option value="" disabled selected>Where did you hear about us?</option>
                    <option>Google Search</option>
                    <option>LinkedIn</option>
                    <option>Social Media</option>
                    <option>Referral</option>
                    <option>Friend/Colleague</option>
                  </select>
                  {errors.discovery && <p className="text-red-500 text-xs ml-1">{errors.discovery}</p>}
                </div>

                <button 
                  type="submit"
                  disabled={isLoading}
                  className={`w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-bold py-4 rounded-2xl shadow-lg hover:shadow-blue-200 hover:-translate-y-1 active:scale-95 transition-all duration-300 ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                >
                  {isLoading ? 'SENDING...' : 'Send Message'}
                </button>
              </form>
            </div>
          </div>

        </div>
      </section>
      
      <Footer />
    </div>
    </>
  );
}

// Reusable Contact Info Component
function ContactInfo({ icon, title, detail, subDetail, isLink }) {
  return (
    <div className="flex gap-4 group">
      <div className="w-12 h-12 shrink-0 rounded-2xl bg-white shadow-sm flex items-center justify-center border border-blue-100 group-hover:bg-blue-600 group-hover:text-white transition-all duration-300 text-blue-600">
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          {icon}
        </svg>
      </div>
      <div>
        <p className="text-[10px] font-bold text-blue-500 uppercase tracking-widest mb-1">{title}</p>
        <p className={`text-gray-800 font-medium leading-snug ${isLink ? 'hover:text-blue-600 cursor-pointer underline decoration-blue-200' : ''}`}>
          {detail}
        </p>
        {subDetail && <p className="text-gray-800 font-medium hover:text-blue-600 cursor-pointer underline decoration-blue-200">{subDetail}</p>}
      </div>
    </div>
  );
}

// Reusable Input Component with error support
function InputGroup({name, label, type = "text", placeholder, required, error}) {
  return (
    <div className="flex flex-col gap-1">
      <label className="text-xs font-bold text-blue-600 uppercase tracking-widest ml-1">
        {label} {required && <span className="text-red-400">*</span>}
      </label>
      <input 
        name={name}
        type={type} 
        placeholder={placeholder}
        className={`w-full px-4 py-3 rounded-2xl bg-blue-50/50 border ${error ? 'border-red-400' : 'border-blue-100'} focus:bg-white focus:ring-2 focus:ring-blue-200 outline-none transition-all`}
      />
      {error && <p className="text-red-500 text-xs ml-1">{error}</p>}
    </div>
  );
}